import { useMemo } from 'react';

function useUTMParams() {
  return useMemo(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      // The plain names are accepted as well, so a funnel can tag a contact with either
      // convention on the iframe URL.
      return {
        source: params.get('utm_source') || params.get('source') || '',
        channel: params.get('utm_channel') || params.get('channel') || '',
        campaign: params.get('utm_campaign') || params.get('campaign') || '',
      };
    } catch {
      return { source: '', channel: '', campaign: '' };
    }
  }, []);
}

export default useUTMParams;
